import { BadgeTranslate } from './badgeTranslate.model';

const badgeTranslateEN: BadgeTranslate = {
  chip: {
    remove: 'Remove badge {{name}}',
    archivedTitle: '{{name}} (archived badge)',
  },
  combobox: {
    triggerAriaLabel: 'Select badges',
    placeholder: 'Add badges',
    searchPlaceholder: 'Search badge',
    loading: 'Loading...',
    empty: 'No badges found',
    createNew: 'New badge',
    createNamed: 'Create "{{name}}"',
    createTitle: 'New badge',
    editTitle: 'Edit badge',
    editAriaLabel: 'Edit badge {{name}}',
    manage: 'Manage badges',
    namePlaceholder: 'Badge name',
    colorLabel: 'Color',
    colorTrigger: 'Color',
    cancel: 'Cancel',
    confirm: 'Create',
    save: 'Save',
  },
  filter: {
    placeholder: 'Filter by badge',
  },
  settings: {
    title: 'Badges',
    description: 'Manage the badges used to classify your leads.',
    newBadge: 'New badge',
    empty: 'No badges registered',
    usageCount: '{{count}} use(s)',
    actions: {
      edit: 'Edit',
      delete: 'Delete',
    },
    form: {
      titleCreate: 'New badge',
      titleEdit: 'Edit badge',
      save: 'Save',
    },
  },
  modal: {
    delete: {
      title: 'Delete badge',
      text: 'Are you sure you want to delete the badge "{{name}}"?',
      secondaryText:
        'The badge will be removed from the catalog, but will remain visible (in archived mode) on leads that already have it.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
  },
  toast: {
    created: 'Badge created',
    updated: 'Badge updated',
    deleted: 'Badge deleted',
    error: {
      create: 'Error creating badge',
      update: 'Error updating badge',
      delete: 'Error deleting badge',
    },
  },
  colors: {
    RED: 'Red',
    PINK: 'Pink',
    PURPLE: 'Purple',
    INDIGO: 'Indigo',
    BLUE: 'Blue',
    LIGHT_BLUE: 'Light blue',
    CYAN: 'Cyan',
    TEAL: 'Teal',
    GREEN: 'Green',
    LIME: 'Lime',
    YELLOW: 'Yellow',
    ORANGE: 'Orange',
    GRAY: 'Gray',
    BLACK: 'Black',
    WHITE: 'White',
  },
};

export default badgeTranslateEN;
